<template>
    <vx-expandable-card>
        <template v-slot:header>Documentation</template>
        <template v-slot:content>
            <div class="mb-4">
                The FTP Pull integration allows Voxie to automatically pull data from your SFTP servers and ingest it
                for processing.
            </div>
            <div class="mb-4">
                Each URL provided must point to either a single file or a directory on your SFTP server. If a directory
                is specified, Voxie will scan all files within that directory and import files that have been added or
                modified since the last pull. If a single file is specified, Voxie will only import that specific file
                if it has been modified since the last pull.
            </div>
            <div class="mb-4">
                All URLs are optional - configure only the data types you need to pull. Each data type can have its own
                SFTP URL, credentials, and SSH key.
            </div>
            <div class="mb-4">
                <strong>Data types:</strong>
            </div>
            <ul class="list-disc list-inside mb-4">
                <li><strong>Contacts:</strong> Contact information to import into Voxie.</li>
                <li><strong>Conversions:</strong> Conversion tracking data.</li>
                <li><strong>Groups:</strong> Group membership and organization data.</li>
            </ul>
            <div class="mb-4">
                <strong>URL format:</strong>
            </div>
            <ul class="list-disc list-inside mb-4">
                <li>Must start with <code>sftp://</code></li>
                <li>
                    Must end with a file extension (<code>.csv</code> or <code>.zip</code>) when pulling a single file.
                    For example: <code>sftp://example.com/path/to/file.csv</code> or
                    <code>sftp://example.com/path/to/data.zip</code>
                </li>
                <li>
                    Must end with a <code>/</code> when importing from a directory. For example:
                    <code>sftp://example.com/path/to/directory/</code>
                </li>
                <li>
                    Must NOT contain embedded credentials (the <code>sftp://user:pass@host</code> format is not allowed)
                </li>
            </ul>
            <div class="mb-4">
                <strong>Authentication:</strong>
            </div>
            <ul class="list-disc list-inside mb-4">
                <li>Each URL requires either a password or an SSH private key for authentication</li>
                <li>Supported SSH key types: RSA, DSA, ECDSA, Ed25519</li>
                <li>Supported key formats: PKCS1, PKCS8, OpenSSH, PuTTY</li>
                <li>
                    <strong>Important:</strong> Passphrase-protected OpenSSH keys (<code
                        >-----BEGIN OPENSSH PRIVATE KEY-----</code
                    >) are <strong>not supported</strong> due to performance issues. Please use an unencrypted SSH key.
                </li>
            </ul>
            <div class="mb-4">
                <strong>File format support:</strong>
            </div>
            <ul class="list-disc list-inside mb-4">
                <li>Supported file formats: <code>.csv</code> (direct) and <code>.zip</code> (containing CSV files)</li>
                <li>
                    ZIP files are automatically extracted.
                    <strong>Only the first CSV file found in the ZIP is processed</strong> - ZIP files containing
                    multiple CSV files are not supported
                </li>
                <li>Maximum file size: 100MB (for both CSV and uncompressed size of ZIP contents)</li>
                <li>Files exceeding the size limit are skipped</li>
            </ul>
        </template>
    </vx-expandable-card>
</template>
<script setup lang="ts">
import { VxExpandableCard } from '@voxie/frontend-components';
</script>
